import { render, staticRenderFns } from "./FwdCkuStts.vue?vue&type=template&id=386514c4&"
import script from "./FwdCkuStts.vue?vue&type=script&lang=js&"
export * from "./FwdCkuStts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports